import { SocialType } from "shared/SocialsShare/SocialsShare";
import React, { FC } from "react";
import { globalJson } from "global/global_json";

export interface SocialsListProps {
  className?: string;
  itemClass?: string;
  socials?: SocialType[];
}

const socialsDemo: SocialType[] = [
  {
    name: "Facebook",
    icon: "lab la-facebook-square",
    href: globalJson.facebook,
  },
  {
    name: "Instagram",
    icon: "lab la-instagram",
    href: globalJson.instagram,
  },
];

const SocialsList: FC<SocialsListProps> = ({
  className = "",
  itemClass = "block",
  socials = socialsDemo,
}) => {
  return (
    <nav
      className={`nc-SocialsList flex space-x-2.5 text-2xl text-neutral-6000 dark:text-neutral-300 ${className}`}
      data-nc-id="SocialsList"
    >
       <a href="https://www.facebook.com/share/1BCe1fWb4m/?mibextid=wwXIfr">
       <svg width="45" height="46" viewBox="0 0 45 46" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="0.5" width="45" height="45" rx="22.5" fill="white" fill-opacity="0.1"/>
<path d="M26.2188 24H23.875V31H20.75V24H18.1875V21.125H20.75V18.9062C20.75 16.4062 22.25 15 24.5312 15C25.625 15 26.7812 15.2188 26.7812 15.2188V17.6875H25.5C24.25 17.6875 23.875 18.4375 23.875 19.25V21.125H26.6562L26.2188 24Z" fill="white"/>
</svg>

            </a>
            <a href="https://www.instagram.com/bluediamond.enterprise/profilecard/?igsh=ZnNpM2t3Y2JrbDh2">
       <svg width="45" height="46" viewBox="0 0 45 46" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="0.5" width="45" height="45" rx="22.5" fill="white" fill-opacity="0.1"/>
<path d="M22.5 19.4062C24.4688 19.4062 26.0938 21.0312 26.0938 23C26.0938 25 24.4688 26.5938 22.5 26.5938C20.5 26.5938 18.9062 25 18.9062 23C18.9062 21.0312 20.5 19.4062 22.5 19.4062ZM22.5 25.3438C23.7812 25.3438 24.8125 24.3125 24.8125 23C24.8125 21.7188 23.7812 20.6875 22.5 20.6875C21.1875 20.6875 20.1562 21.7188 20.1562 23C20.1562 24.3125 21.2188 25.3438 22.5 25.3438ZM27.0625 19.2812C27.0625 19.75 26.6875 20.125 26.2188 20.125C25.75 20.125 25.375 19.75 25.375 19.2812C25.375 18.8125 25.75 18.4375 26.2188 18.4375C26.6875 18.4375 27.0625 18.8125 27.0625 19.2812ZM29.4375 20.125C29.5 21.2812 29.5 24.75 29.4375 25.9062C29.375 27.0312 29.125 28 28.3125 28.8438C27.5 29.6562 26.5 29.9062 25.375 29.9688C24.2188 30.0312 20.75 30.0312 19.5938 29.9688C18.4688 29.9062 17.5 29.6562 16.6562 28.8438C15.8438 28 15.5938 27.0312 15.5312 25.9062C15.4688 24.75 15.4688 21.2812 15.5312 20.125C15.5938 19 15.8438 18 16.6562 17.1875C17.5 16.375 18.4688 16.125 19.5938 16.0625C20.75 16 24.2188 16 25.375 16.0625C26.5 16.125 27.5 16.375 28.3125 17.1875C29.125 18 29.375 19 29.4375 20.125ZM27.9375 27.125C28.3125 26.2188 28.2188 24.0312 28.2188 23C28.2188 22 28.3125 19.8125 27.9375 18.875C27.6875 18.2812 27.2188 17.7812 26.625 17.5625C25.6875 17.1875 23.5 17.2812 22.5 17.2812C21.4688 17.2812 19.2812 17.1875 18.375 17.5625C17.75 17.8125 17.2812 18.2812 17.0312 18.875C16.6562 19.8125 16.75 22 16.75 23C16.75 24.0312 16.6562 26.2188 17.0312 27.125C17.2812 27.75 17.75 28.2188 18.375 28.4688C19.2812 28.8438 21.4688 28.75 22.5 28.75C23.5 28.75 25.6875 28.8438 26.625 28.4688C27.2188 28.2188 27.7188 27.75 27.9375 27.125Z" fill="white"/>
</svg>


            </a>
      <a href="https://www.tiktok.com/@blue.diamond.ent">
        <svg
          width="45"
          height="46"
          viewBox="0 0 45 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <rect
            y="0.5"
            width="45"
            height="45"
            rx="22.5"
            fill="white"
            fill-opacity="0.1"
          />
          <mask
            id="mask0_466_153"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="14"
            y="14"
            width="16"
            height="17"
          >
            <rect
              x="14"
              y="14.5"
              width="16"
              height="16"
              fill="url(#pattern0_466_153)"
            />
          </mask>
          <g mask="url(#mask0_466_153)">
            <rect x="9" y="8.5" width="32" height="30" fill="white" />
          </g>
          <defs>
            <pattern
              id="pattern0_466_153"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlinkHref="#image0_466_153" transform="scale(0.0078125)" />
            </pattern>
            <image
              id="image0_466_153"
              width="128"
              height="128"
              xlinkHref="data:image/png;base64,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"
            />
          </defs>
        </svg>
      </a>
    </nav>
  );
};

export default SocialsList;
